/* global window */
/* eslint-disable no-console */

import url from 'url';
import querystring from 'querystring';
import Path from './Path';
import addReferrer from './addReferrer';
import getPathTemplate from './getPathTemplate';
import processPathname from './processPathname';
import queryPreprocessor from './queryPreprocessor';
import queryPostprocessor from './queryPostprocessor';
import funnels from './funnels';
export default async function getPath(pageName) {
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let {
    absolute = false,
    basePath = true,
    brand = 'atc',
    hash,
    target = 'lsc',
    search = true,
    referrer = false,
    req,
    useUpdatedVdpPath = false
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // Create a query object via an initial preprocessor
  let query = queryPreprocessor({
    pageName,
    query: data
  });
  const rawQueryData = {
    ...query
  };
  let pathname = getPathTemplate({
    pageName,
    query,
    brand,
    basePath,
    useUpdatedVdpPath
  });
  try {
    const path = new Path(pathname, query);

    // process the path
    await path.build();

    // extract the compiled pathname
    pathname = path.getPathname();
    query = path.getQuery();

    // allow the pathname & query to be processed with page specific logic
    ({
      query,
      pathname
    } = await processPathname({
      query,
      rawQueryData,
      pathname,
      pageName,
      brand,
      basePath
    }));
  } catch (err) {
    console.error(`There was an issue compiling the path: '${pathname}'`);
    console.error(err);
    throw err;
  }

  // process the query after the URL object has been built
  query = await queryPostprocessor({
    pageName,
    query,
    target
  });

  // Handle referrer query param addition
  if (referrer) {
    query = addReferrer(query, req);
  }

  // Remove params have value type object
  Object.keys(query).forEach(key => {
    if (typeof query[key] === 'object' && !Array.isArray(query[key])) {
      delete query[key];
    }
  });

  // reorder query params alphabetically
  query = Object.keys(query).sort().reduce((acc, key) => ({
    ...acc,
    [key]: query[key]
  }), {});

  // use the querystring stringify method (AND NOT NODE) to ensure arrays are "encoded properly"
  // ATC uses duplicate keys to signify query arrays
  const searchString = search && querystring.stringify(query);

  // handle absolute path creation
  if (absolute) {
    let protocol;
    let host;
    if (req) {
      protocol = req.headers['x-forwarded-proto'] || req.protocol;
      host = req.headers.host;
    } else {
      protocol = window.location.protocol;
      host = window.location.host;
    }

    // Throw error if we don't have what we need to build a url
    if (!protocol || !host) {
      throw Error('atc-paths needs a protocol and host to generate pathnames. Most likely you have forgotten to pass the req object in the options to allow server generation on the server.');
    }

    // generate the final url
    return url.format({
      protocol,
      host,
      pathname,
      search: searchString,
      hash
    }).toString();
  }

  // Node's URL format requires a host and protocol but we often want to build relative requests
  // We place a fake host to allow path generation and then remove it after
  // Its hacky... I feel dirty... I know... I am sorry :(
  const fakeHost = '__fakeHost__';
  const fakeProtocol = 'http:';
  let result = url.format({
    protocol: fakeProtocol,
    host: fakeHost,
    pathname,
    search: searchString,
    hash
  }).toString();

  // Only KBB's FIND DEALER funnel need to have a trailing slash
  // added to the end of the pathname if one is not already present
  if (brand === 'kbb' && result && result.includes(funnels.FIND_DEALER_KBB) && !result.includes('/?') && result.includes('?')) {
    result = result.replace('?', '/?');
  }

  // replace the initial host
  return result.replace(`${fakeProtocol}//${fakeHost}`, '');
}